/*
 * Authors: mariushirjanu
 * Created: 11/10/2021
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'multiselect-new-option',
  template: `
    <button class="btn btn-primary btn-sm" (click)="onButtonClick()" translate>{{label}}</button>
  `
})
export class MultiselectNewOptionComponent {
  @Input() public label:string;
  @Output() public onClick:EventEmitter<null> = new EventEmitter();

  public onButtonClick = ():void => {
    this.onClick.emit();
  };
}